import React, { useState, useEffect } from 'react';
import axiosInstance from '../../Services/axiosCommon';

const UseGetDataSearchByEqu = (url, params=null) => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [credit, setCredit] = useState(0);
  const [advance, setAdvance] = useState(0);
  const [dataLoading, setDataLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [totalPro, setTotalPro] = useState(0);
  const [quantity, setQuantity] = useState(0); // Add quantity state

  async function getData() {
    setDataLoading(true);
    try {
      const res = await axiosInstance.get(url, { params });
      params?.page!=="" && params?.pageCount!==""? setData(res?.data?.data || []) : setData(res?.data?.data || []) ;
      params?.page!=="" && params?.pageCount!=="" ? setTotalCount(res?.data?.pagination?.total ||res?.data?.pagination?.total|| 0) : setTotalCount(0)
      res.data?.credit && setCredit(res.data?.credit)
      res.data?.advance && setAdvance(res.data?.advance)
      setTotal(res?.data?.pagination?.total || 0)
      setTotalPro(res?.data?.pagination?.total || 0)
      setQuantity(res?.data?.quantity || 0) // Set quantity from response
      console.log("total", total)
      setDataLoading(false);
    } catch (error) {
      console.log(error);
      setDataLoading(false);
    }
  }
  
  useEffect(() => {
    getData();
  }, [url, JSON.stringify(params)]);

  return { data, totalCount, credit, advance, getData, dataLoading, total, totalPro, quantity }; // Return quantity
};

export default UseGetDataSearchByEqu;